module.exports = __webpack_public_path__ + "static/media/qr-frame.min.c12fb66c.png";